import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import ReportPreview from '../previews/ReportPreview';

interface PreviewContextType {
  openReportPreview: (reportId: string) => void;
  closePreview: () => void;
}

const PreviewContext = createContext<PreviewContextType | null>(null);

export const usePreview = () => {
  const context = useContext(PreviewContext);
  if (!context) {
    throw new Error('usePreview must be used within a PreviewProvider');
  }
  return context;
};

export const PreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [reportPreview, setReportPreview] = useState<{ isOpen: boolean; reportId: string }>({
    isOpen: false,
    reportId: '',
  });

  const openReportPreview = useCallback((reportId: string) => {
    setReportPreview({ isOpen: true, reportId });
  }, []);

  const closePreview = useCallback(() => {
    setReportPreview({ isOpen: false, reportId: '' });
  }, []);

  const contextValue = useMemo(
    () => ({
      openReportPreview,

      closePreview,
    }),
    [openReportPreview, closePreview],
  );

  return (
    <PreviewContext.Provider value={contextValue}>
      {children}
      <ReportPreview reportId={reportPreview.reportId} isOpen={reportPreview.isOpen} onClose={closePreview} />
    </PreviewContext.Provider>
  );
};

export default PreviewProvider;
